import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { SezioneParcelleStragiudiziali } from '../../../models/sezioni/sezione-parcelle-stragiudiziali';
import { AvvisoParcellaAddComponent } from './avviso-parcelle-add.component';
import { ParcelleStragiudizialiAddComponent } from './parcelle-stragiudiziali-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [parcella-stragiudiziale-mod-add]',
  templateUrl: 'parcella-stragiudiziale-mod-add.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ParcellaStragiudizialeModAdd implements OnInit {
  @Output() onReturn: EventEmitter<SezioneParcelleStragiudiziali> = new EventEmitter<SezioneParcelleStragiudiziali>();
  @ViewChild('formParcellaStragiudizialeAdd') formParcellaStragiudiziale: ParcelleStragiudizialiAddComponent;
  @ViewChild('formAvvisoParcellaAdd') formAvvisoParcellaAdd: AvvisoParcellaAddComponent;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  isParcella: boolean = false

  constructor(private changeDetectorRef: ChangeDetectorRef){

  }

  ngOnInit(){
    this.isPrd = PropertiesSettings.ID_TENANTS_PRD();
  }

  inizializza(idSezione: string,
              idFascicolo: string,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlInsert: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number) {
    /*if(this.isPrd) {
      this.formParcellaStragiudiziale.inizializza(idSezione,
                                            idFascicolo,
                                            idSezioneLegali,
                                            idSezioneEconomica,
                                            urlInsert,
                                            urlReadSezioneLegali,
                                            urlReadSezioneEconomica,
                                            urlGetScaglioni,
                                            tipoFascicolo,
                                            tipoPratica); }
    else*/
    this.changeDetectorRef.detectChanges(); //serve per checkare la view e i children (utile nel caso ci siano componenti con *ngIf che possono cambiare)
    if (this.isPrd) {
      if(this.isParcella){
        this.formParcellaStragiudiziale.inizializza(idSezione,
          idFascicolo,
          idSezioneLegali,
          idSezioneEconomica,
          urlInsert,
          urlReadSezioneLegali,
          urlReadSezioneEconomica,
          urlGetScaglioni,
          tipoFascicolo,
          tipoPratica);
      }else {
        this.formAvvisoParcellaAdd.inizializza(idSezione,
          idFascicolo,
          idSezioneLegali,
          idSezioneEconomica,
          urlInsert,
          urlReadSezioneLegali,
          urlReadSezioneEconomica,
          urlGetScaglioni,
          tipoFascicolo,
          tipoPratica);
      }
      }
    openModal('modaladdParcellaStragiudiziale');
  }

  createForm() {
    /*if(this.isPrd) this.formParcellaStragiudiziale.createForm();
    else */
    if (this.isPrd && !this.isParcella){
      this.formAvvisoParcellaAdd.createForm(); 
      this.formAvvisoParcellaAdd.setTextEmpty();
    } 
    else {
      this.formParcellaStragiudiziale.createForm();
      this.formParcellaStragiudiziale.setTextEmpty();
    }
  }

  manageModal(sezioneParcelleStragiudiziali: SezioneParcelleStragiudiziali) {
      closeModal('modaladdParcellaStragiudiziale');
      this.onReturn.emit(sezioneParcelleStragiudiziali);
  }
}
